import { defineComponent as a, createElementBlock as L, openBlock as l, normalizeClass as r, unref as e, createElementVNode as m } from "vue";
import p from "../../../utils/mapClasses.mjs";
import i from "../../../props/size.mjs";
import { useStar as c } from "../composables/useStar.mjs";
const z = /* @__PURE__ */ a({
  __name: "CdrStar00",
  props: {
    size: i
  },
  setup(t) {
    const o = t, {
      style: s,
      sizeClass: n
    } = c(o.size);
    return (_, f) => (l(), L("svg", {
      class: r(e(p)(e(s), "cdr-rating__star", e(n))),
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [m("path", {
      class: r(e(s)["cdr-rating__star--empty"]),
      d: `M12.1702 17.7643L11.9688 17.6359L11.7673 17.7643L6.37635 21.1984L7.81044
        14.6842L7.85695 14.473L7.69738 14.3269L2.8485 9.88945L9.21759 9.31204L9.44623
        9.29131L9.53174 9.07825L11.9688 3.00672L14.4058 9.07825L14.4913 9.29131L14.7199
        9.31204L21.089 9.88945L16.2401 14.3269L16.0806 14.473L16.1271 14.6842L17.5612
        21.1984L12.1702 17.7643Z`,
      "stroke-width": "0.75"
    }, null, 2)], 2));
  }
});
export {
  z as default
};
